import {useContext, useEffect, useState} from "react";
import api from "services/api";
import AdminTurismoModal from './modal';
import './style.css';
import {formatImage} from "components/formatos";
import config from 'config';
import PAGINACAO from "components/paginacao";
import {CidadeContext} from "services/cidade";
import RADIO from "components/radio";


function AdminTurismo(){
    const [lturismo, setLTurismo] = useState([]);
    const [tipo, setTipo] = useState(0);
    // removed unused loading state
    const { cod_cidade } = useContext(CidadeContext)


    // Modal
    const [operacao, setOperacao] = useState('')
    const [dados, setDados] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    function closeAdminTurismoModal(){
        setIsOpen(false);
    }

    useEffect(()=>{
        api.get(`${config.ADM_TURISMO}?tipo=${tipo}&cod_cidade=${cod_cidade}`)
            .then(response => {
                setLTurismo(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    },[isOpen, cod_cidade, tipo]);

    function novoTurismo(){
        setDados(           
            {
                "id_turismo": 0,
                "tipo": tipo,
                "descricao": "",
                "url_foto": "",
                "url_site": "",
                "ind_ativo": "S",
                "cod_cidade": cod_cidade,
            } 
        );
        setIsOpen(true);
    }

    function editarTurismo(linha){
        setOperacao('UPDATE')
        setDados(linha);
        setIsOpen(true);
    }
    function descicaotipo(tipo) {
        switch (tipo) {
            case 0:
                return 'Turismo';
            case 1:
                return 'Hoteis';
            case 2:
                return 'Alimentação';
            case 3:
                return 'Eventos';
                case 4:
                return 'Uteis';
            default:
                return 'Unknown';
        }
    }

    return (
        <div>
            <AdminTurismoModal 
                isOpen={isOpen}
                onRequestClose={closeAdminTurismoModal}                 
                operacao={operacao}
                dados={dados}
            /> 
            
            <div className="admin-header-section mb-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <h2 className="section-title mb-0">Gestão de Turismo e Lazer</h2>
                    <button 
                        className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 shadow-sm" 
                        onClick={() => novoTurismo()}
                        style={{ borderRadius: '12px' }}
                    >
                        <i className="fas fa-plus"></i>
                        <span>Novo Registro</span>
                    </button>
                </div>

                <div className="modern-filter-bar mt-4 p-4 bg-card-admin rounded-4">
                    <label className="form-label fw-bold text-muted mb-3 d-block">Filtrar por Categoria</label>
                    <RADIO
                      chave={'tipo'}
                      alabel={['Turismo', 'Hotéis', 'Alimentação', 'Eventos', 'Úteis']}
                      avalores={[0,1,2,3,4]}
                      setValor={setTipo}
                      valor={tipo}
                    />
                </div>
            </div>

            <PAGINACAO
                data={lturismo}
                itemsPerPage={12}
                renderItems={(currentItems) => (
                    <div className="row g-4">
                        {currentItems.map((e, index) => (
                            <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={`turism-${index}`}>
                                <div className="turismo-admin-card h-100 bg-card-admin rounded-4 overflow-hidden position-relative transition-all" onClick={() => editarTurismo(e)}>
                                    <div className="p-3 border-bottom d-flex align-items-center justify-content-between bg-light-subtle">
                                        <span className="text-muted small fw-bold">ID: #{e.id_turismo}</span>
                                        <span className="badge bg-info-subtle text-info border border-info-subtle" style={{fontSize: '0.7rem'}}>
                                            {descicaotipo(e.tipo)}
                                        </span>
                                    </div>
                                    
                                    <div className="turismo-admin-preview bg-light" style={{ height: '140px' }}>
                                        {formatImage(e.url_foto) ? (
                                            <img src={formatImage(e.url_foto)} alt={e.descricao} className="w-100 h-100 object-fit-cover" />
                                        ) : (
                                            <div className="d-flex align-items-center justify-content-center h-100 text-muted opacity-25">
                                                <i className="fas fa-map-marked-alt fa-3x"></i>
                                            </div>
                                        )}
                                    </div>

                                    <div className="p-4">
                                        <h5 className="turismo-admin-title mb-3 text-truncate-2" title={e.descricao}>
                                            {e.descricao}
                                        </h5>
                                        {e.url_site && (
                                            <div className="text-muted small text-truncate mb-2" style={{fontSize: '0.75rem'}}>
                                                <i className="fas fa-link me-1 text-primary"></i>
                                                {e.url_site}
                                            </div>
                                        )}
                                        <div className={`status-indicator d-flex align-items-center gap-2 small ${e.ind_ativo === 'S' ? 'text-success' : 'text-danger'}`}>
                                            <i className={`fas fa-${e.ind_ativo === 'S' ? 'check-circle' : 'times-circle'}`}></i>
                                            <span style={{fontSize: '0.75rem'}}>{e.ind_ativo === 'S' ? 'Visível no App' : 'Oculto'}</span>
                                        </div>
                                    </div>
                                    
                                    <div className="p-3 border-top bg-light-subtle d-flex justify-content-center">
                                        <button className="btn btn-outline-primary btn-sm rounded-3 px-4 w-100">
                                            <i className="fas fa-edit me-1"></i> Gerenciar Registro
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            />
        </div>
    );
}

export default AdminTurismo;